import { PatientTreatment } from "../api/patientTreatments";

export function isSameDayTreatment(t: PatientTreatment) {
  return t.ended_at != null && t.started_at.equals(t.ended_at);
}

export function isOngoingTreatment(t: PatientTreatment) {
  return t.ended_at == null;
}
